/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import Body from 'components/shared/body/body_container';
import Frame from 'components/frames/frame_container';
import ProgressBar from 'components/shared/progressbar/progressbar';
// utils
import { log } from 'utils/logger';
import { url } from 'utils/urls';
import { isDMPEnabled } from 'utils/headersettings';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/splash/splash_styles';
import { createStyles } from 'utils/styles';
import { preloadStyleImages } from "utils/preloader";
preloadStyleImages(styles);
const sheet = createStyles(styles, {link:true});



/* ========== ~~~~~~~~~~ SPLASH SCREEN: CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class SplashScreen extends Component {
    constructor(props) {
        super(props);
        this.isAvailable = this.isSplashScreenAvailable();
        this.removalRequested = false;
        this.timeoutId = null;
        log('SPLASH', 'isAvailable:', this.isAvailable)
    }

    componentWillMount() {
        this.props.setTotalFrameCount(this.props.contentId, 1);
        // dynamically add background image to partner logo from settings file
        if(!!this.props.partnerLogoSrc) sheet.addRule('partner', { backgroundImage: `url(${url.image.client}${this.props.partnerLogoSrc})` });
    }

    componentDidMount() {
        if (this.props.cookieCheckDone && this.isInView()) this.removeSplashScreen()
    }

    componentWillReceiveProps(nextProps) {
        if((this.props.cookieCheckDone || nextProps.cookieCheckDone) && (this.isInView(this.props) || this.isInView(nextProps))) {
            this.removeSplashScreen();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutId)
    }

    isInView = (props=this.props) => !this.isAvailable || props.inViewRecorded || props.inViewSettings === 'none' ||
        (props.cookieCheckDone && props.inView === null);

    isValidURL = () => !!this.props.partnerLogoUrl;

    isSplashScreenAvailable = () => ![`DFP_WITH_SAFEFRAME`, `HARD_CODED_WITH_SAFEFRAME`].includes(this.props.integrationType);

    removeSplashScreen = () => {
        if(this.removalRequested) return null;
        this.removalRequested = true;

        this.timeoutId = setTimeout(() => {
            this.props.advanceFrame(this.props.contentId);
            clearTimeout(this.timeoutId)
        }, 2000);
    };

    createFrames = () => <Frame id={null} type={'splash'} frameIndex={0} contentId={this.props.contentId} markup={this.createMarkup()} />;

    createMarkup = () => (
        <div className={`${sheet.classes.uniquecontent} uniquecontent`}>
            <a className={`${sheet.classes.partner} partner clickable-${this.isValidURL()}`} href={`${this.props.partnerLogoUrl}`} target="_blank"><span className={`accessibility`}>${this.props.partnerLogoText}</span></a>
            <div className={`${sheet.classes.company} company`}>
                { this.props.enableInsticatorBranding ? <div className={`text`}>{`${this.props.logoText}`}</div> : null }
                { this.props.enableInsticatorBranding ? <a className={`image`} href={'https://www.insticator.com'} target="_blank"><span className={`accessibility`}>Insticator</span></a> : null }
                <ProgressBar type={`result`} duration={isDMPEnabled() ? 20000 : 10000} fillingDelay={0} direction={`leftToRight`} isActive={true} shouldKillItself={false} />
            </div>
        </div>
    );

    render() {
        if (!this.props.isActiveContent) return null;
        const isOptIn = this.props.screenName === 'optIn'
        return(
            <div className={`${sheet.classes.uniquecontent} uniquecontent ${this.props.currentContentStatusType} cookieChecked-${this.props.cookieCheckDone} inview-${this.props.cookieCheckDone && (this.props.inView || this.props.inViewSettings === 'none')}`}>
                <Body contentId={this.props.contentId} markup={this.createFrames()} />
                <div className={`curtains ${isOptIn ? 'optIn' : ''}`}>
                    <div className={`curtain left`}/>
                    <div className={`curtain right`}/>
                </div>
            </div>
        );
    }
}


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default SplashScreen;
